export function numberValidation(x) {
  if (Number.isNaN(Number(x))) {
    return '';
  } else {
    return x;
  }
}
